import axios from 'axios';
import { EntityState, serializeAxiosError, IQueryParams } from 'app/shared/reducers/reducer.utils';
import { IIndicatorDto, defaultValue } from 'app/shared/model/indicator-dto.model';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IKpiResponse, IKpiTimeResponse } from 'app/shared/model/indicator-dto';
import { PeriodicType } from 'app/shared/model/enumerations/periodicType';

const initialState: EntityState<IIndicatorDto> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};
export interface IBrakingProps extends IQueryParams {
  sensor: string | null;
  periodicType: PeriodicType | null;
  truckImplementId?: number | string;
  companyId?: number | null;
  dateStart?: string | null;
  dateEnd?: string | null;
}

const apiUrl = '/api/indicator-index';

// Actions

export const getBrakingIndexPerTime = createAsyncThunk(
  'indicatorBrakingIndex/fetch_braking_per_time_periodic',
  async ({ sensor, periodicType, truckImplementId, companyId, dateStart, dateEnd }: IBrakingProps) => {
    const apiUrlComplete = `${apiUrl}/time/${sensor}${truckImplementId ? `/${truckImplementId}` : ''}/${periodicType}${
      companyId ? `?searchCompanyId=${companyId}` : ''
    }`;
    const params = {
      dateStart,
      dateEnd,
    };
    const response = await axios.get<IKpiTimeResponse>(apiUrlComplete, { params });
    return response.data;
  },
  { serializeError: serializeAxiosError }
);

export const getBrakingIndexPerVehicleAndPlate = createAsyncThunk(
  'indicatorBrakingIndex/fetch_braking_per_vehicles_and_plate_periodic',
  async ({ sensor, periodicType, companyId, dateStart, dateEnd }: IBrakingProps) => {
    const apiUrlComplete = `${apiUrl}/statistics/${sensor}/${periodicType}${companyId ? `?searchCompanyId=${companyId}` : ''}`;
    const params = {
      dateStart,
      dateEnd,
    };
    const response = await axios.get<IKpiResponse>(apiUrlComplete, { params });
    return response.data;
  },
  { serializeError: serializeAxiosError }
);

// Slice

const indicatorBrakingIndexSlice = createSlice({
  name: 'indicatorBrakingIndex',
  initialState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getBrakingIndexPerTime.fulfilled, (state, action) => {
        state.loading = false;
        state.entity.kpiPerTime = action.payload;
      })
      .addCase(getBrakingIndexPerTime.pending, state => {
        state.loading = true;
      })
      .addCase(getBrakingIndexPerTime.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message || 'Error fetching data';
      })
      .addCase(getBrakingIndexPerVehicleAndPlate.fulfilled, (state, action) => {
        state.loading = false;
        state.entity.kpiPerVehicleAndStatistics = action.payload;
      })
      .addCase(getBrakingIndexPerVehicleAndPlate.pending, state => {
        state.loading = true;
      })
      .addCase(getBrakingIndexPerVehicleAndPlate.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message || 'Error fetching data';
      });
  },
});

export const { reset } = indicatorBrakingIndexSlice.actions;

export default indicatorBrakingIndexSlice.reducer;
